import React, { useState } from "react";
import "./weather.css";
import WeatherInfo from "./weatherInfo.js";
import WeatherForecast from "./weatherForecast.js";
import axios from "axios";

function Weather(props) {
  let [weatherData, setWeatherData] = useState({ ready: false });
  let [city, setCity] = useState(props.defaultCity);
  let [unit, setUnit] = useState("imperial");
  function handleResponse(response) {
    setWeatherData({
      ready: true,
      city: response.data.city,
      temperature: response.data.temperature.current,
      description: response.data.condition.description,
      humidity: response.data.temperature.humidity,
      wind: response.data.wind.speed,
      imgUrl: response.data.condition.icon_url,
      imgDesc: response.data.condition.icon,
      date: new Date(response.data.time * 1000),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function search() {
    let apiKey = "d723abdbd1batbf0d4fo3fa95586fbba";
    let apiURL = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=imperial`;
    axios.get(apiURL).then(handleResponse);
  }

  function handleSearching(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <div className="header">
          <h2>React Weather</h2>
          <form className="search-form" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Enter city name"
              autoComplete="off"
              onChange={handleSearching}
              required
              className="search-input"
            />
            <input type="submit" className="search-button" value="Search" />
          </form>
        </div>
        <WeatherInfo data={weatherData} unit={unit} setUnit={setUnit} />
        <WeatherForecast data={weatherData} unit={unit} />
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}

export default Weather;
